import { useSlate } from 'slate-react';
import { useTagTextDeleteWarning } from '../hooks/useTagTextDeleteWarning';
import { TagTextDeleteWarningModal } from './TagTextDeleteWarningModal';

export const TagTextDeleteWarning = () => {
  const editor = useSlate();
  const { showWarning, handleConfirm, handleRevert } = useTagTextDeleteWarning(editor);

  return <TagTextDeleteWarningModal show={showWarning} onConfirm={handleConfirm} onRevert={handleRevert} />;
};
